var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.isLink
      ? _c(
          "a",
          { staticClass: "text-normal", attrs: { href: _vm.getLink() } },
          [
            _c("p", { staticClass: "small" }, [
              _vm._v(_vm._s(_vm.formattedDate)),
              _c("br"),
              _vm._v(_vm._s(_vm.formattedTime))
            ])
          ]
        )
      : _c("p", { staticClass: "small" }, [
          _vm._v(_vm._s(_vm.formattedDate)),
          _c("br"),
          _vm._v(_vm._s(_vm.formattedTime))
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40d48cb2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d48cb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/DateTimeComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-40d48cb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/DateTimeComponent.vue
// module chunks = 0